import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="protected-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-primary" />
      </div>
    );
  }
  if (user === false) {
    // Preserve where the user was heading so login can send them back
    const target = `${loc.pathname}${loc.search || ""}`;
    const q = target && target !== "/login" ? `?returnTo=${encodeURIComponent(target)}` : "";
    return <Navigate to={`/login${q}`} replace />;
  }
  return children;
}
